<template>
  <div>
    <view-table
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="materialPriceApplications"
        @reset="resetHandle"
        @delete="deleteHandle"
        @addOrEdit="addEditHandle"
        @select="selectHandle">
      <template slot="otherBtn">
        <el-upload
            action=""
            :http-request="importFile"
            :show-file-list="false"
            style="float: left; margin-right: 4px;">
          <el-button type="primary" :loading="importLoading">导入模板</el-button>
        </el-upload>
        <el-button
            type="primary"
            plain
            icon="el-icon-download"
            @click="downloadModel">
          模板下载
        </el-button>
      </template>
      <template slot="adSearch">
        <div class="vm-search">
          <el-form :inline="true" :model="filter" label-width="65px" @keyup.enter.native="loadData(1)">
            <el-form-item label="申请编号">
              <el-input v-model.trim="filter.applicationNo" placeholder="请输入申请编号" clearable/>
            </el-form-item>
            <el-form-item label="申请状态">
              <el-select v-model="filter.status" clearable placeholder="请选择申请状态">
                <el-option label="全部" value="-1"/>
                <el-option label="草稿" value="0"/>
                <el-option label="待审核" value="1"/>
                <el-option label="驳回" value="3"/>
                <el-option label="已审批" value="4"/>
              </el-select>
            </el-form-item>
            <el-form-item label="申请人">
              <el-input v-model.trim="filter.creatorName" placeholder="请输入申请人" clearable/>
            </el-form-item>
            <el-form-item label="创建时间">
              <el-date-picker
                  v-model="createTimeRange"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  value-format="yyyy-MM-dd"
                  @change="dateRangeChange('createTimeRange', 'createTimeBegin', 'createTimeEnd')"/>
            </el-form-item>
            <el-form-item label="提交时间">
              <el-date-picker
                  v-model="submitTimeRange"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  value-format="yyyy-MM-dd"
                  @change="dateRangeChange('submitTimeRange', 'submitTimeBegin', 'submitTimeEnd')"/>
            </el-form-item>
            <el-form-item label="通过时间">
              <el-date-picker
                  v-model="passTimeRange"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  value-format="yyyy-MM-dd"
                  @change="dateRangeChange('passTimeRange', 'passTimeBegin', 'passTimeEnd')"/>
            </el-form-item>
          </el-form>
        </div>
      </template>
      <template slot="actionBtn" slot-scope="scope">
        <el-button
            v-if="limits.subAuth"
            type="primary"
            :loading="submitLoading"
            :disabled="scope.row.status !== 0"
            @click="submitHandle(scope.row)">
          提交
        </el-button>
      </template>
    </view-table>
    <material-price-application-edit ref="materialPriceApplicationEdit" @save-success="loadData"/>
  </div>
</template>

<script>

  import ViewTable from "@/components/ViewTable";
  import MaterialPriceApplicationEdit from "@/views/information/MaterialPrice/MaterialPriceApplicationEdit";
  import loginUtil from "@/util/loginUtil";


  export default {
    name: "MaterialPriceApplicationList",
    components: {ViewTable,MaterialPriceApplicationEdit},
    data() {
      return {
        limits: {
          addAuth: this.$auth(644),
          editAuth: this.$auth(645),
          delAuth: this.$auth(647),
          subAuth: this.$auth(646),
          importAuth: this.$auth(643),
          creatDeliveryAuth: this.$auth(135),
        },
        filter: {
          applicationNo:"",
          status: "",
          creatorName: "",
          createTimeBegin: "",
          createTimeEnd: "",
          submitTimeBegin: "",
          submitTimeEnd: "",
          passTimeBegin: "",
          passTimeEnd: "",
        },
        deleteLoading:false,
        importLoading:false,
        createTimeRange:[],
        submitTimeRange:[],
        passTimeRange:[],
        columnsProperty: [
          {
            key: "applicationNo",
            width: 130,
            align: "center",
            render: (h, params) => {
              return h(
                "span",
                {
                  style: {
                    color: "#2d8cf0",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.$refs.materialPriceApplicationEdit.open(params.row, false);
                    },
                  },
                },
                params.row.applicationNo,
              );
            },
          },
          {
            key: "creatorName",
            width: 100,
          },
          {
            key: "creatorDepartment",
          },
          {
            key: "createTime",
            width: 200,
          },
          {
            key: "submitTime",
            width: 200,
          },
          {
            key: "passTime",
            width: 200,
          },
          {
            key: "statusName",
            width: 150,
          },
          {
            key: "action",
            width: 250,
            slot:"action",
            fixed: "right",
          },
        ],
      };
    },

    watch: {
      "filter.deliveryBeginDate": {
        handler(newVal) {
          if (newVal) {
            this.deliveryDateRange = [];
            this.deliveryDateRange.push(this.filter.deliveryBeginDate);
            this.deliveryDateRange.push(this.filter.deliveryEndDate);
          }
        },
      },
      "filter.orderBeginDate": {
        handler(newVal) {
          if (newVal) {
            this.createDateRange = [];
            this.createDateRange.push(this.filter.orderBeginDate);
            this.createDateRange.push(this.filter.orderEndDate);
          }
        },
      },
      "filter.submitBeginDate": {
        handler(newVal) {
          if (newVal) {
            this.submitDateRange = [];
            this.submitDateRange.push(this.filter.submitBeginDate);
            this.submitDateRange.push(this.filter.submitEndDate);
          }
        },
      },
    },

    methods: {
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },

      dateRangeChange(timeRange, timeStart, timeEnd) {
        if (this[timeRange]) {
          this.filter[timeStart] = this[timeRange][0];
          this.filter[timeEnd] = this[timeRange][1];
        } else {
          this.filter[timeStart] = "";
          this.filter[timeEnd] = "";
        }
      },


      selectHandle(selection) {
        this.selection = selection;
      },

      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
      },

      addEditHandle(row) {
        this.$refs.materialPriceApplicationEdit.open(row,true);
      },

      deleteHandle(row) {
        this.$confirm("确定删除吗?","提示",{type:"warning"})
          .then(()=>{
            this.deleteLoading=true;
            this.$http.delete("basic","materialPriceApplications",row.pkId)
              .then((resp)=>{
                if (resp.success) {
                  this.deleteLoading=false;
                  this.$message.success("删除成功");
                  this.loadData();
                }
              }).finally(()=>{
                this.deleteLoading=false;
                this.loadData();
              });
          }); 
      },

      //未提交、退单可以编辑删除
      otherAuth(row) {
        if (row.status === 0) {
          return  false;
        } else {
          return  true;
        }
      },

      submitHandle(row) {
        this.$confirm("确定提交吗?","提示",{type:"warning"})
          .then(()=>{
            this.deleteLoading=true;
            this.$http.get("basic",`materialPriceApplications/submit/${row.pkId}`)
              .then((resp)=>{
                if (resp.success) {
                  this.deleteLoading=false;
                  this.$message.success("提交成功");
                  this.loadData();
                }
              }).finally(()=>{
                this.deleteLoading=false;
                this.loadData();
              });
          });
      },

      //导入
      importFile(params) {
        this.importLoading = true;
        let formData = new FormData();
        formData.append("file", params.file);
        formData.append("Authorization", loginUtil.getToken());
        this.$http.post("basic", "base_MaterialPriceApplicationDetails/getDetailByFile", formData).then((res) => {
          if (res.success) {
            this.importLoading = false;
            this.loadData(1);
            this.$message.success("导入成功");
          } else {
            this.importLoading = false;
            this.$message.error("导入失败");
          }
        }).catch(() => {
          this.importLoading = false;
          this.$message.error("导入失败");
        });
      },

      //下载导入模板
      downloadModel() {
        window.open("/file/价格导入模板.xlsx");
      },
    },
  };
</script>
